import { Card } from "antd";
import React, { FC, useEffect, useState } from "react";
import { StudentActivitiesFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { serialize } from "serializr";
import V2DashboardService from "../../../services/v2/Institute/Admin/DashboardService/dashboard.service";
import { brandColors } from "../../../shared/utils/brandColors";
import ClassDetails from "./ClassDetails";

interface LoginDetailCardProps {
  branch: any;
  additionalFilters: StudentActivitiesFilterModel;
  data: any;
}

const LoginDetailCard: FC<LoginDetailCardProps> = ({
  branch,
  additionalFilters,
  data,
}) => {
  const [showClassDetails, setShowClassDetails] = useState(false);

  return (
    <>
      <Card
        className="school-details"
        key={branch.value}
        onClick={() => {
          setShowClassDetails(!showClassDetails);
        }}
        title={branch.label || "Default Title"} // Customize as needed
        style={{
          width: 300,
          marginBottom: 16,
          backgroundColor: brandColors[branch.value % 8],
        }}
        loading={false}
      >
        <div className="login-count total">
          <p>Total Students</p>
          <p>{data.total}</p>
        </div>
        <div className="login-count sub-total">
          <p>Logged In</p>
          <p>{data.logins}</p>
        </div>
        <div className="login-count sub-total">
          <p>Not LoggedIn</p>
          <p>{data.notLogins}</p>
        </div>
      </Card>
      <ClassDetails
        drawerVisible={showClassDetails}
        key={`drawer${branch.value}`}
        onClose={() => setShowClassDetails(false)}
        branch={branch}
        filters={additionalFilters}
      />
    </>
  );
};

export default LoginDetailCard;
